import { PropsWithChildren, useState } from 'react';
import { useGlobalContext } from '@/globalContext';
import Config from '@utils/config';
import { HeaderTab } from '@components/commons';
import styles from './screen.module.scss';
import { Checkbox } from '@yoti/ui-kit-components-react/checkbox';
import { Button } from '@yoti/ui-kit-components-react/button';

interface ScreenProps {
    'data-qa'?: string;
}

const Screen = ({
    children,
    'data-qa': dataQa = 'consent-screen',
}: PropsWithChildren<ScreenProps>) => {
    const { scanConfiguration, setScanConfiguration } = useGlobalContext();
    const consent = scanConfiguration?.consent;
    const [consentValue, setConsentValue] = useState(false);

    const allowConsent = () => {
        setConsentValue(false); // Reset the checkbox value in case the user come back to this screen.
        setScanConfiguration({ ...scanConfiguration, consent: true });
    };

    if (Config.showConsent && !consent) {
        return (
            <div data-qa={dataQa}>
                <HeaderTab tabs={['Consent']} />
                <div className={styles['consent']}>
                    <p className={styles['consent__text']}>{Config.consentText1}</p>
                    <p className={styles['consent__text']}>{Config.consentText2}</p>
                    <br />
                    <div className={styles['consent__form']}>
                        <Checkbox
                            label={Config.consentCheckboxLabel}
                            onChange={() => {
                                setConsentValue(!consentValue);
                            }}
                            checked={consentValue}
                        />

                        <Button
                            variation="solid-standard"
                            size="small"
                            onClick={allowConsent}
                            disabled={!consentValue}
                            fullWidth={true}
                        >
                            ALLOW
                        </Button>
                    </div>
                </div>
            </div>
        );
    }

    return <div data-qa={dataQa}>{children}</div>;
};

export default Screen;
